export default {"src":"/_next/static/media/ozon.e82ca1ac.svg","height":15,"width":69,"blurWidth":0,"blurHeight":0};